import React, { useEffect, useMemo, useState } from "react";
import Tv from "../../assets/icons/tv.svg";
import LiveVirtualFilter from "../components/shared/LiveVirtualFilter";
import NewsAndPromotions from "../components/shared/NewsAndPromotions";
import { EventDTO, formatTime, getExchangeEvents, SPToBFIdMap, useAppSelector } from "@hypexone/uicore";

import moment from "moment";
import { useNavigate } from "react-router-dom";
import { getCompetitionSlug } from "../../utils/hooks/event.hooks";
import Button from "../components/shared/Button/Button";

const HorseRacing: React.FC = () => {
  const navigate = useNavigate();
  const [isLiveInEventPage, setIsLiveInEventPage] = useState(false);
  const [isVirtualInEventPage, setIsVirtualInEventPage] = useState(false);


  const { loggedIn } = useAppSelector((state) => state.auth);
  const {langData} = useAppSelector((state) => state.cms);
  const {
    events: catalogEvents,
    selectedEventType,
    selectedCompetition,
  } = useAppSelector((state) => state.catalog);

  const [value, setValue] = useState("");
  const [competitionList, setCompetitions] = useState<{
    [key: string]: EventDTO[];
  }>({});

  const events = useMemo(
    () =>
      getExchangeEvents(
        catalogEvents,
        SPToBFIdMap[selectedEventType.id]
          ? SPToBFIdMap[selectedEventType.id]
          : selectedEventType.id,
        selectedCompetition.id
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [catalogEvents]
  );

  useEffect(() => {
    if (competitionList) {
      setValue(Object?.keys(competitionList)?.[0]);
    }
  }, [competitionList]);

  useEffect(() => {
    if (events && events.length > 0) prepareCompetitionList(events);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events]);

  const prepareCompetitionList = (events: EventDTO[]) => {
    const competitions: { [key: string]: EventDTO[] } = {};
    const unique = Array.from(
      new Set(events.map((item) => item?.competitionId?.split("_")[0]))
    );

    for (let key of unique) {
      competitions[key] =
        events?.filter((item) => item?.competitionId?.startsWith(key + "_")) ??
        [];
    }
    const sorted = Object.keys(competitions)
      .sort()
      .reduce((accumulator, key) => {
        accumulator[key] = competitions[key];
        return accumulator;
      }, {} as { [key: string]: EventDTO[] });

    setCompetitions(sorted);
    if (value === "") setValue(unique[0]);
  };

  const isLive = (date: Date) => {
    const duration = moment.duration(moment(date).diff(moment()));
    return duration?.asMinutes() < 10 ? true : false;
  };

  const handleKeyClick = (key: string) => {
    setValue(key);
  };
  const handleEventPageFilterChange = (
    newIsLive: boolean,
    newIsVirtual: boolean
  ) => {
    setIsLiveInEventPage(newIsLive);
    setIsVirtualInEventPage(newIsVirtual);
  };

  return (
    <div className="flex flex-col min-h-screen">
      <div className="flex flex-col flex-1 gap-[1px]">
        <NewsAndPromotions hasPromotions />

        <div className="flex flex-col">
          <LiveVirtualFilter 
           pageTitle={selectedEventType.name}
              isLive={isLiveInEventPage}
              isVirtual={isVirtualInEventPage}
              onFilterChange={handleEventPageFilterChange}/>
          {/* <div className="py-1 px-1 w-full"> */}
          <div className="flex bg-blue4">
            {Object?.keys(competitionList).map((key) => {
              const isSelected = key === value;
              return (
                <Button
                  key={key}
                  onClick={() => handleKeyClick(key)}
                  className={`${
                    isSelected ? "bg-white rounded-t-[4px]" : "text-white"
                  } py-2 px-3`}
                >
                  {key}
                </Button>
              );
            })}
          </div>
        </div>

        {competitionList[value] && competitionList[value].length > 0 ? (
          competitionList[value].map((competition) => (
            <div
              key={competition.eventName}
              className="flex flex-col flex-wrap md:flex-row border-b border-b-gray21 bg-gray20 p-2 justify-between w-full"
            >
              <div className="flex items-center font-robotoCondensed text-[14px] font-normal leading-[15px] mb-2 md:mb-0 mr-4">
                <img className="mr-2" src={Tv} alt="TV" />
                <span>{competition.eventName}</span>
              </div>

              <div className="flex flex-wrap gap-2 text-black">
                {competition.raceMarkets &&
                  competition.raceMarkets.length > 0 &&
                  competition.raceMarkets.map((raceMarket) => (
                    <Button
                      className={`${
                        raceMarket.marketTime && isLive(raceMarket.marketTime)
                          ? "bg-blue1 text-white"
                          : "bg-gray-400"
                      } px-3 py-1 rounded text-black `}
                      onClick={() => {
                        navigate(
                          competition.providerName?.toLowerCase() ===
                            "sportradar" && competition.catId === "SR VIRTUAL"
                            ? loggedIn
                              ? `/exchange_sports/virtuals/${
                                  selectedEventType.slug
                                }/${getCompetitionSlug(
                                  competition.competitionName
                                )}/${competition.eventSlug}/${btoa(
                                  `${competition.sportId}:${competition.competitionId}:${competition.eventId}`
                                )}`
                              : "/login"
                            : `/exchange_sports/${
                                selectedEventType.slug
                              }/${getCompetitionSlug(
                                competition.competitionName
                              )}/${competition.eventSlug}/${btoa(
                                `${competition.sportId}:${competition.competitionId}:${competition.eventId}`
                              )}`
                        );
                      }}
                    >
                      {raceMarket.marketTime &&
                        formatTime(raceMarket.marketTime)}
                    </Button>
                  ))}
              </div>
            </div>
          ))
        ) : (
          <div className="flex justify-center">{langData?.['no_data_found']}</div>
        )}
      </div>
      
    </div>
  );
};

export default HorseRacing;
